module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/s-button/s-button.component.scss
// module id = ./src/app/shared/components/s-button/s-button.component.scss
// module chunks = main